import { css } from 'styled-components';
import { COLORS } from '../../../config/theme';

const style = () => css`
    .insights-toolbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        margin-bottom: 16px;
        flex-wrap: wrap;

        .insights-title {
            font-size: 24px;
            font-weight: 700;
            color: ${(props) => props.theme[COLORS.PRIMARY_TEXT]};
        }

        .ant-picker-range {
            border-radius: 5px;
        }
    }

    .summary-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
        gap: 12px;
        margin-bottom: 16px;
    }

    .summary-card,
    .chart-card,
    .type-card {
        background: ${(props) => props.theme[COLORS.WHITE]};
        border-radius: 5px;
        padding: 16px;
    }

    .summary-card-label {
        color: ${(props) => props.theme[COLORS.ICONS]};
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
    }

    .summary-card-value {
        margin-top: 8px;
        color: ${(props) => props.theme[COLORS.PRIMARY_TEXT]};
        font-size: 28px;
        font-weight: 800;
        line-height: 1;

        .summary-card-percentage {
            color: ${(props) => props.theme[COLORS.ICONS]};
            font-size: 16px;
            font-weight: 700;
            margin-left: 6px;
            white-space: nowrap;
        }
    }

    .chart-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
        gap: 16px;
    }

    .chart-card {
        min-width: 0;
    }

    .chart-card-header,
    .type-card-header {
        color: ${(props) => props.theme[COLORS.PRIMARY_TEXT]};
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 12px;
    }

    .type-card {
        margin-top: 16px;
    }

    .loading-content,
    .empty-content {
        min-height: 320px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .insights-error {
        margin-bottom: 16px;
    }

    @media (max-width: 768px) {
        .chart-grid {
            grid-template-columns: 1fr;
        }

        .insights-toolbar {
            align-items: flex-start;
            flex-direction: column;
        }

        .insights-toolbar .ant-picker {
            width: 100%;
        }
    }
`;

export default style();
